import React, { useEffect, useState } from 'react';
import { Image, PrimaryButton, TextField, Text, DefaultButton, Button, BaseButton } from '@fluentui/react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react';

import { ContextualMenu } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { usePostFeedback } from 'app/services/request-api';
import { ICreateFeedbackDto } from 'generated/request-backend';
import './FeedbackContent.scss';
import fcIconTerrible from 'app/static/icons/fc_icon_terrible.svg';
import fcIconBad from 'app/static/icons/fc_icon_bad.svg';
import fcIconOkay from 'app/static/icons/fc_icon_okay.svg';
import fcIconGood from 'app/static/icons/fc_icon_good.svg';
import fcIconGreat from 'app/static/icons/fc_icon_great.svg';
import fcIconTerribleActive from 'app/static/icons/fc_icon_terrible_active.svg';
import fcIconBadActive from 'app/static/icons/fc_icon_bad_active.svg';
import fcIconOkayActive from 'app/static/icons/fc_icon_okay_active.svg';
import fcIconGoodActive from 'app/static/icons/fc_icon_good_active.svg';
import fcIconGreatActive from 'app/static/icons/fc_icon_great_active.svg';
import { Trans, useTranslation } from 'react-i18next';
import { keyPress } from 'app/components/helpers';
const FeedbackContent: React.FC<{ showOnScreen: boolean; handleShowOnScreen: () => void }> = ({ showOnScreen, handleShowOnScreen }) => {
    const { t: translate } = useTranslation();
    useEffect(() => {
        const preLoadedImages = [fcIconTerribleActive, fcIconBadActive, fcIconOkayActive, fcIconGoodActive, fcIconGreatActive];
        preLoadedImages.forEach((image: string) => {
            const img = document.createElement('img');
            img.src = image;
        });
    }, []);
    const isDraggable = false;
    const [category, setCategory] = useState('');
    const [reaction, setReaction] = useState('');
    const [feedbackComment, setFeedbackComment] = React.useState('');
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);

    const { mutate: postFeedback } = usePostFeedback();

    const handleCommentChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFeedbackComment((event.target as HTMLInputElement | HTMLTextAreaElement).value);
    };

    const handleCategoryToggle = (categoryName: string) => {
        setCategory(categoryName);
    };

    const handleReactionToggle = (event: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>, reactionName: string) => {
        setReaction(reactionName);
    };

    const handleReactionMouseOver = (event: React.MouseEvent<HTMLImageElement>, source: string) => {
        (event.target as HTMLImageElement).src = source;
    };

    const handleReactionMouseOut = (event: React.MouseEvent<HTMLImageElement>, source: string, reactionName: string) => {
        (event.target as HTMLImageElement).src = source;
        if (reaction === reactionName) {
            (event.target as HTMLImageElement).src = getIcon(reactionName, true);
        }
    };

    const handleFeedbackFocus = (event: React.FocusEvent<HTMLDivElement>, reactionName: string) => {
        if(event.type === 'focus') {
            (document.getElementById(`${reactionName}-img`) as HTMLImageElement).src = getIcon(reactionName, true)
        } else if(event.type === "blur") {
            if(reactionName !== reaction) {
                (document.getElementById(`${reactionName}-img`) as HTMLImageElement).src = getIcon(reactionName, false)
            }
        }
    }

    const handleCategoryFocus = (event: React.FocusEvent<HTMLDivElement | HTMLButtonElement | HTMLAnchorElement | BaseButton | Button | HTMLSpanElement>, categoryName: string) => {
        if(event.type === 'focus') {
            (event.target as HTMLDivElement | HTMLButtonElement | HTMLAnchorElement | HTMLSpanElement).classList.add('active')
        } else if(event.type === 'blur') {
            if(category !== categoryName) {
                (event.target as HTMLDivElement | HTMLButtonElement | HTMLAnchorElement | HTMLSpanElement).classList.remove('active')
            }
        }
    }

    const getIcon = (reactionName: string, active: boolean) => {
        let icon;
        
        switch (reactionName) {
            case 'terrible':
                active ? icon = fcIconTerribleActive : icon = fcIconTerrible
                break;
            case 'bad':
                active ? icon = fcIconBadActive : icon = fcIconBad
                break;
            case 'okay':
                active ? icon = fcIconOkayActive : icon = fcIconOkay
                break;
            case 'good':
                active ? icon = fcIconGoodActive : icon = fcIconGood
                break;
            case 'great':
                active ? icon = fcIconGreatActive : icon = fcIconGreat
                break;
            default:
                break;
        }

        return icon
    };

    const renderFeedbackElement = (defaultSource: string, activeSource: string, reactionName: string) => {
        return (
            <div 
                id={reactionName}
                className="fc-icon-wrap" 
                tabIndex={0}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyPress(e, () => handleReactionToggle(e, reactionName))}
                onFocus={(e) => handleFeedbackFocus(e, reactionName)}
                onBlur={(e) => handleFeedbackFocus(e, reactionName)}
                aria-label={reactionName + " graphic" + (reaction === reactionName ? ", selected" : "")}
                aria-selected={reaction === reactionName}
                role='option'
                onClick={e => handleReactionToggle(e, reactionName)}>
                    <Image
                        onKeyPress={(e: React.KeyboardEvent<HTMLImageElement>) => keyPress(e, () => handleReactionToggle(e, reactionName))}
                        id={`${reactionName}-img`}
                        className="fc-icon"
                        tabIndex={-1}
                        src={reaction === reactionName ? activeSource : defaultSource}
                        alt={reaction}
                        onMouseOver={(event) => {
                            handleReactionMouseOver(event, activeSource);
                        }}
                        onMouseOut={(event) => {
                            handleReactionMouseOut(event, defaultSource, reactionName);
                        }}
                        data-testid={defaultSource}
                    />
                    <div className="fc-icon-desc">
                        <Trans>{reactionName[0].toUpperCase() + reactionName.substring(1)}</Trans>
                    </div>
            </div>
        )
    };

    const renderCategoryButton = (categoryName: string) => {
        let categoryLabel = categoryName[0].toUpperCase() + categoryName.substring(1);
        if(categoryName === 'bug') { 
            categoryLabel = "Report a " + categoryLabel;
        };
        const labelId = categoryName + '-label';
        
        return (
            <DefaultButton
                className={category === categoryName ? 'active' : ''}
                onClick={() => {
                    handleCategoryToggle(categoryName);
                }}
                onFocus={e => handleCategoryFocus(e, categoryName)}
                onBlur={e => handleCategoryFocus(e, categoryName)}
                data-testid={`${categoryName}-button`}
                role='option'
                aria-labelledby={labelId}
                aria-selected={category === categoryName}
                >
                <i className="ms-Icon ms-Icon--OfficeChat" aria-hidden="true"></i>{' '}
                <span id={labelId}>
                    <Trans>{categoryLabel}</Trans>
                </span>
            </DefaultButton>
        )
    };

    const getFeedbackCategory = (value: string) => {
        let res = 0;
        switch (value) {
            case 'suggestion':
                res = 1;
                break;
            case 'compliment':
                res = 2;
                break;
            case 'bug':
                res = 3;
                break;

            default:
                break;
        }
        return res;
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        if (reaction && category && feedbackComment) {
            const feedback : ICreateFeedbackDto = {
                feedbackMessage: feedbackComment,
                experience: reaction,
                feedbackCategory: getFeedbackCategory(category)
            };
            postFeedback(feedback);
            handleShowOnScreen();
        } else {
            toggleHideDialog();
        }
    };

    const dialogContentProps = {
        type: DialogType.normal,
        subText: 'Please provide an appropriate feedback to continue.'
    };

    const modalProps = React.useMemo(() => {
        const modalPropsStyles = { main: { maxWidth: 450 } };

        const dragOptions = {
            moveMenuItemText: 'Move',
            closeMenuItemText: 'Close',
            menu: ContextualMenu
        };

        return {
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: isDraggable ? dragOptions : undefined
        };
    }, [isDraggable]);

    return (
        <div className={`fc-content ${showOnScreen ? '' : 'hidden'}`}>
            <div className="fc-title">
                <Trans>Feedback</Trans>
            </div>
            <div>
                <Text>
                    <Trans>We would love to hear about your experience using the Admin portal</Trans>:
                </Text>
            </div>
            <div
                className="fc-icons-container"
                tabIndex={0}
                aria-label='feedback option list'>
                {renderFeedbackElement(fcIconGreat, fcIconGreatActive, 'great')}
                {renderFeedbackElement(fcIconGood, fcIconGoodActive, 'good')}
                {renderFeedbackElement(fcIconOkay, fcIconOkayActive, 'okay')}
                {renderFeedbackElement(fcIconBad, fcIconBadActive, 'bad')}
                {renderFeedbackElement(fcIconTerrible, fcIconTerribleActive, 'terrible')}
            </div> 
            <div>
                <Text>
                    <Trans>Please select your feedback category</Trans> :
                </Text>
            </div>
            <div className="fc-category" role='listbox' aria-label='feedback category'>
                {renderCategoryButton('suggestion')}
                {renderCategoryButton('compliment')}
                {renderCategoryButton('bug')}
            </div>
            <form onSubmit={handleSubmit} data-testid="form-button">
                <div>
                    <Text>
                        <Trans>Please provide your feedback below</Trans> :
                    </Text>
                </div>
                <div className="fc-textfield-wrap">
                    <TextField
                        aria-label="feedback-textArea"
                        data-testid="feedback-field-test"
                        value={feedbackComment}
                        placeholder="Details help make this feedback more impactful. What, when, and why are good things to include."
                        multiline
                        resizable={false}
                        borderless
                        rows={6}
                        onChange={handleCommentChange}
                    />
                </div>
                <div className="fc-form-btn-wrap">
                    <DefaultButton href='/' className="default">
                        <Trans>Cancel</Trans>
                    </DefaultButton>
                    <DefaultButton data-testid="submit-btn-test" type="submit" className="primary">
                        <Trans>Submit</Trans>
                    </DefaultButton>
                </div>
            </form>
            <Dialog
                hidden={hideDialog}
                onDismiss={toggleHideDialog}
                dialogContentProps={dialogContentProps}
                modalProps={modalProps}>
                <DialogFooter>
                    <PrimaryButton onClick={toggleHideDialog} text={translate('OK')} />
                </DialogFooter>
            </Dialog>
        </div>
    );
};

export default FeedbackContent;
